import React from 'react'
import Icon from 'react-icon-base'

const Qualification = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g id="Qualification" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Qualification" transform="translate(-133.000000, -2354.000000)">
        <rect id="Rectangle" fill="#F1F1F1" x="0" y="8" width="1200" height="3822" />
        <g id="Group" transform="translate(35.000000, 410.000000)">
          <g id="Qualification" transform="translate(0.000000, 1834.000000)">
            <rect
              id="Rectangle-Copy-2"
              stroke="#DDDDDD"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="1135"
              height="282"
              rx="4"
            />
            <g id="Group-17" transform="translate(30.000000, 112.000000)" stroke="#3498DB">
              <g id="Group" transform="translate(73.000000, 0.000000)">
                <polyline
                  id="Path"
                  strokeWidth="2.25"
                  strokeLinejoin="round"
                  transform="translate(19.881189, 29.106655) scale(-1, 1) rotate(20.000000) translate(-19.881189, -29.106655) "
                  points="22.693689 24.8599094 22.693689 34.4623774 19.881189 32.2123774 17.068689 34.4623774 17.068689 23.7509323"
                />
                <polyline
                  id="Path"
                  strokeWidth="2.25"
                  strokeLinejoin="round"
                  transform="translate(6.118811, 29.106655) rotate(20.000000) translate(-6.118811, -29.106655) "
                  points="8.93131105 24.8599094 8.93131105 34.4623774 6.11881105 32.2123774 3.30631105 34.4623774 3.30631105 23.7509323"
                />
                <path
                  d="M16.6828393,-0.744543527 L19.1812294,2.29379667 L23.0617042,2.93829581 L23.7062033,6.81877063 L26.7445435,9.31716066 L25.3624587,13 L26.7445435,16.6828393 L23.7062033,19.1812294 L23.0617042,23.0617042 L19.1812294,23.7062033 L16.6828393,26.7445435 L13,25.3624587 L9.31716066,26.7445435 L6.81877063,23.7062033 L2.93829581,23.0617042 L2.29379667,19.1812294 L-0.744543527,16.6828393 L0.637541251,13 L-0.744543527,9.31716066 L2.29379667,6.81877063 L2.93829581,2.93829581 L6.81877063,2.29379667 L9.31716066,-0.744543527 L13,0.637541251 L16.6828393,-0.744543527 Z"
                  id="Star-Copy-2"
                  strokeWidth="2"
                  strokeLinejoin="round"
                />
                <circle id="Oval-Copy" strokeWidth="1.6875" cx="13" cy="13" r="9.15625" />
                <polygon
                  id="Star"
                  strokeWidth="1.125"
                  strokeLinejoin="round"
                  points="13 16.06 9.47328849 17.854102 10.0897671 13.945592 7.2936609 11.145898 11.2013771 10.524408 13 7 14.7986229 10.524408 18.7063391 11.145898 15.9102329 13.945592 16.5267115 17.854102"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
)

Qualification.defaultProps = {
  size: 30
}

export default Qualification
